export const vinteraBusinessIdentity = Object.freeze({
  legalName: "Vintera Health LLC",
  displayName: "Vintera Health",
  supportEmail: "vinterahealth@gmail.com",
  phoneDisplay: "(718) 540-4990",
  phoneHref: "+17185404990",
  faxDisplay: "(718) 233-2602",
  websiteUrl: "https://vinterahealth.com",
  address: Object.freeze({
    line1: "207 Taylor Street",
    city: "Staten Island",
    state: "NY",
    postalCode: "10310",
    country: "US",
  }),
});

export function vinteraSupportMailto(subject?: string) {
  const query = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  return `mailto:${vinteraBusinessIdentity.supportEmail}${query}`;
}

export function vinteraSupportPhoneHref() {
  return `tel:${vinteraBusinessIdentity.phoneHref}`;
}

export function vinteraPostalAddress() {
  const { line1, city, state, postalCode } = vinteraBusinessIdentity.address;
  return `${line1}, ${city}, ${state} ${postalCode}`;
}

export function vinteraEmailSignatureLines() {
  return [
    vinteraBusinessIdentity.legalName,
    `Email: ${vinteraBusinessIdentity.supportEmail}`,
    `Phone: ${vinteraBusinessIdentity.phoneDisplay}`,
    `Fax: ${vinteraBusinessIdentity.faxDisplay}`,
  ];
}
